import { render, staticRenderFns } from "./FolderEdit.vue?vue&type=template&id=16ece520"
import script from "./FolderEdit.vue?vue&type=script&lang=js"
export * from "./FolderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports